import React, { useEffect, useState } from 'react';
import { GrabberIcon } from './icons/DashboardIcons';
import {
  formatGrabberCount,
  formatGrabberRate,
  formatSessionDuration,
  GrabberStatsSnapshot,
} from '../utils/grabberStats';
import './CrackerController.css';
import './GrabberManager.css';
import './AtlasPageLayout.css';

interface GrabberDashboardStatsProps {
  stats: GrabberStatsSnapshot;
  isGrabbing: boolean;
}

const GrabberDashboardStats: React.FC<GrabberDashboardStatsProps> = ({ stats, isGrabbing }) => {
  const [, setTick] = useState(0);

  useEffect(() => {
    if (!isGrabbing) return;
    const interval = setInterval(() => setTick((t) => t + 1), 1000);
    return () => clearInterval(interval);
  }, [isGrabbing]);

  if (!isGrabbing) return null;

  return (
    <div className="ix-page ix-page--module cracker-shell cracker-shell--atlas mb-4">
      <header className="ix-command-bar">
        <div className="cracker-panel-title min-w-0">
          <div className="cracker-panel-icon cracker-panel-icon--active">
            <GrabberIcon size={18} />
          </div>
          <div className="min-w-0">
            <p className="cracker-label">Active harvest</p>
            <h2 className="cracker-heading text-base sm:text-lg">Live telemetry</h2>
            <p className="cracker-subheading hidden sm:block">
              Domain generation running on your instance
            </p>
          </div>
        </div>
        <div className="ix-command-bar__actions">
          <span className="cracker-badge cracker-badge--green">Live</span>
        </div>
      </header>

      <section className="ix-tile">
        <div className="cracker-metrics-grid">
          <div className="cracker-metric">
            <div className="cracker-metric-value cracker-metric-value--gold">
              {formatGrabberCount(stats.foundDomains)}
            </div>
            <div className="cracker-metric-label">Domains</div>
            <div className="cracker-metric-sub">{formatGrabberCount(stats.processedIPs)} IPs processed</div>
          </div>
          <div className="cracker-metric">
            <div className="cracker-metric-value">{formatGrabberRate(stats.rate)}</div>
            <div className="cracker-metric-label">Speed</div>
            <div className="cracker-metric-sub">{formatGrabberCount(stats.generatedIPs)} generated</div>
          </div>
          <div className="cracker-metric">
            <div className="cracker-metric-value">
              {formatSessionDuration(stats.startTime, isGrabbing)}
            </div>
            <div className="cracker-metric-label">Duration</div>
            <div className="cracker-metric-sub">{formatGrabberCount(stats.errors)} errors</div>
          </div>
          <div className="cracker-metric col-span-2 md:col-span-1">
            <div className="cracker-metric-value cracker-metric-value--green">LIVE</div>
            <div className="cracker-metric-label">Status</div>
            <div className="cracker-metric-sub">{formatGrabberCount(stats.duplicateIPs)} duplicates</div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default GrabberDashboardStats;
